module.exports = __webpack_public_path__ + "static/media/bo.5f3fef09.svg";